import * as angular from "angular";

angular
  .module('bringoz.admin.persistence')
  .config(configuration);

function configuration($provide) {
  $provide.constant('IndexedDB', window.indexedDB);

  //Data base & data models
  $provide.value('BringozDB', {
    name: 'Bringoz',
    version: 1,
    instance: null,
    onupgrade: function (evt) {
      var _db = evt.target.result;
      _db.createObjectStore('Delivereis', {keyPath: 'id'});
    },
    updateVersion: function () {
      var self = this;
      self.version += 1;
    }
  });

  $provide.value('Deliveries_DS', {
    objectStoreName: 'Deliveries',
    keyName: 'id'
  });

  $provide.value('PricePlans_DS', {
    objectStoreName: 'PricePlans',
    keyName: 'pricePlanId'
  });

  $provide.value('Routes_DS', {
    objectStoreName: 'Routes',
    keyName: 'rid'
  });

  $provide.value('FulfillmentStep_DS', {
    objectStoreName: 'FulfillmentStep',
    keyName: 'id'
  });

  $provide.value('Commission_DS', {
    objectStoreName: 'Commissions',
    keyName: 'id'
  });

  $provide.value('Consolidated_Commission_DS', {
    objectStoreName: 'ConsolidatedCommissions',
    keyName: 'id'
  });

  $provide.value('Payments_DS', {
    objectStoreName: 'Payments',
    keyName: 'id'
  });

  $provide.value('Tasks_DS', {
    objectStoreName: 'Tasks',
    keyName: 'id'
  });

  $provide.value('Accounts_DS', {
    objectStoreName: 'Accounts',
    keyName: 'id'
  });

  $provide.value('AccountsCommissionsSummary_DS', {
    objectStoreName: 'AccountsCommissionsSummary',
    keyName: 'id'
  });

  $provide.value('Shippers_DS', {
    objectStoreName: 'Shippers',
    keyName: 'id'
  });

  $provide.value('Teams_DS', {
    objectStoreName: 'Teams',
    keyName: 'id'
  });

  $provide.value('Agents_DS', {
    objectStoreName: 'Agents',
    keyName: 'id'
  });

  $provide.value('AgentsAssistants_DS', {
    objectStoreName: 'AgentsAssistants',
    keyName: 'id'
  });

  $provide.value('AgentPaymentCollection_DS', {
    objectStoreName: 'AgentPaymentCollection',
    keyName: 'id'
  });

  $provide.value('WalletsBalances_DS', {
    objectStoreName: 'WalletsBalances_DS',
    keyName: 'id'
  });

  $provide.value('Location_DS', {
    objectStoreName: 'location',
    keyName: 'holderId'
  });

  $provide.value('LogisticsVehicleLocation_DS', {
    objectStoreName: 'LogisticsVehicleLocation',
    keyName: 'holderId'
  });

  $provide.value('ServiceArea_DS', {
    objectStoreName: 'ServiceAreas',
    keyName: 'areaId'
  });

  $provide.value('Auctions_DS', {
    objectStoreName: 'Auctions',
    keyName: 'aid'
  });

  $provide.value('BillingAccounts_DS', {
    objectStoreName: 'BillingAccounts',
    keyName: 'id'
  });

  $provide.value('BillingOrders_DS', {
    objectStoreName: 'BillingOrders',
    keyName: 'id'
  });

  $provide.value('Consolidated_BillingOrders_DS', {
    objectStoreName: 'ConsolidatedBillingOrders',
    keyName: 'id'
  });

  $provide.value('BillingAccountTransactions_DS', {
    objectStoreName: 'BillingAccountsTransactions',
    keyName: 'tid'
  });

  $provide.value('PricePlanBundle_DS', {
    objectStoreName: 'PricePlanBundles',
    keyName: 'id'
  });

  $provide.value('Admins_DS', {
    objectStoreName: 'Admins',
    keyName: 'id'
  });
  $provide.value('ServiceAccounts_DS', {
    objectStoreName: 'ServiceAccounts',
    keyName: 'id'
  });
  $provide.value('Coordinations_DS', {
    objectStoreName: 'Coordinations',
    keyName: 'id'
  });
  $provide.value('Agreements_DS', {
    objectStoreName: 'Agreements',
    keyName: 'id'
  });
  $provide.value('Attachments_DS', {
    objectStoreName: 'Attachments',
    keyName: 'name'
  });
  $provide.value('TextTemplates_DS', {
    objectStoreName: 'TextTemplates',
    keyName: 'id'
  });
  $provide.value('LeanPlanning_DS', {
    objectStoreName: 'leanPlanning',
    keyName: 'id'
  });
  $provide.value('LeanPlanningRoutes_DS', {
    objectStoreName: 'leanPlanningRoutes',
    keyName: 'rid'
  });
  $provide.value('User_DS', {
    objectStoreName: 'users',
    keyName: 'id'
  });
  $provide.value('Survey_DS', {
    objectStoreName: 'survey',
    keyName: 'id'
  });
  $provide.value('ServiceAnalysis_DS', {
    objectStoreName: 'serviceAnalysisTask',
    keyName: 'id'
  })
  $provide.value('policy_DS', {
    objectStoreName: 'policy',
    keyName: 'id'
  });
  $provide.value('Addresses_DS', {
    objectStoreName: 'addresses',
    keyName: 'id'
  });
  $provide.value('Branches_DS', {
    objectStoreName: 'branches',
    keyName: 'id'
  });
  $provide.value('CancellationReasons_DS', {
    objectStoreName: 'cancellationReasons',
    keyName: 'id'
  });
  $provide.value('ActionReasons_DS', {
    objectStoreName: 'actionReasons',
    keyName: 'id'
  });
  $provide.value('ConfigurationProfiles_DS', {
    objectStoreName: 'configurationProfiles',
    keyName: 'id'
  });
  $provide.value('AgentConfigurationProfiles_DS', {
    objectStoreName: 'agentConfigurationProfiles',
    keyName: 'id'
  });
  $provide.value('Depots_DS', {
    objectStoreName: 'depots',
    keyName: 'id'
  });
  $provide.value('Customers_DS', {
    objectStoreName: 'customers',
    keyName: 'id'
  });
  $provide.value('ServicePoints_DS', {
    objectStoreName: 'servicePoints',
    keyName: 'id'
  });
  $provide.value('Expenses_DS', {
    objectStoreName: 'expenses',
    keyName: 'id'
  });
  $provide.value('Workload_DS', {
    objectStoreName: 'workload',
    keyName: 'id'
  });
  $provide.value('AgentInventoryTransactions_DS', {
    objectStoreName: 'agentInventoryTransactions',
    keyName: 'id'
  });
  $provide.value('ExpensesCategories_DS', {
    objectStoreName: 'expensesCategories',
    keyName: 'id'
  });
  $provide.value('Devices_DS', {
    objectStoreName: 'devices',
    keyName: 'id'
  });
  $provide.value('Fulfillment_Pageable_DS', {
    objectStoreName: 'fulfillment',
    keyName: 'id'
  });
  $provide.value('Vehicles_DS', {
    objectStoreName: 'Vehicles',
    keyName: 'id'
  });
  $provide.value('LogisticsVehicles_DS', {
    objectStoreName: 'LogisticsVehicles',
    keyName: 'id'
  });
  $provide.value('Webhooks_DS', {
    objectStoreName: 'Webhooks',
    keyName: 'id'
  });
  $provide.value('Tags_DS', {
    objectStoreName: 'Tags',
    keyName: 'id'
  });
  $provide.value('WorkingSlots_DS', {
    objectStoreName: 'WorkingSlots',
    keyName: 'id'
  });
  $provide.value('Shifts_DS', {
    objectStoreName: 'Shifts',
    keyName: 'id'
  });
  $provide.value('Schedule_DS', {
    objectStoreName: 'Schedule',
    keyName: 'id'
  });
  $provide.value('SchedulingProject_DS', {
    objectStoreName: 'SchedulingProject',
    keyName: 'id'
  });
  $provide.value('ScheduleTemplates_DS', {
    objectStoreName: 'ScheduleTemplates',
    keyName: 'id'
  });
  $provide.value('SubTasksTemplates_DS', {
    objectStoreName: 'SubTask',
    keyName: 'templateId'
  });
  $provide.value('OmsOrders_DS', {
    objectStoreName: 'OmsOrders',
    keyName: 'id'
  });
  $provide.value('Planning_Projects_DS', {
    objectStoreName: 'PlanningProjects',
    keyName: 'id'
  });
  $provide.value('Planning_Templates_Default_Draft', {
    objectStoreName: 'PlanningTemplatesDefaultDraft',
    keyName: 'id'
  });
  $provide.value('Planning_Projects_Process_Tracking_DS', {
    objectStoreName: 'PlanningProjectsProcessTracking',
    keyName: 'id'
  });
  $provide.value('Planning_Drafts_DS', {
    objectStoreName: 'PlanningDrafts',
    keyName: 'id'
  });
  $provide.value('Planning_Draft_Routes_DS', {
    objectStoreName: 'PlanningDraftRoutes',
    keyName: 'id'
  });
  $provide.value('Labels_DS', {
    objectStoreName: 'Labels',
    keyName: 'id'
  });
  $provide.value('Skills_DS', {
    objectStoreName: 'Skills',
    keyName: 'id'
  });
  $provide.value('SelfPickups_DS', {
    objectStoreName: 'SelfPickup',
    keyName: 'id'
  });
  $provide.value('Timeline_DS', {
    objectStoreName: 'Timeline',
    keyName: 'entityId'
  });
  $provide.value('Itineraries_DS', {
    objectStoreName: 'Itineraries',
    keyName: 'id'
  });
  $provide.value('Itineraries_Pageable_DS', {
    objectStoreName: 'Itineraries_Pageable'
  });
  $provide.value('Routes_Pageable_DS', {
    objectStoreName: 'Routes_Pageable'
  });
  $provide.value('AgentResourceBindings_DS', {
    objectStoreName: 'AgentResourceBindings',
    keyName: 'id'
  });
  $provide.value('ResourceAllocations_DS', {
    objectStoreName: 'ResourceAllocations',
    keyName: 'id'
  });
  $provide.value('ScheduleBinding_DS', {
    objectStoreName: 'ScheduleBinding',
    keyName: 'id'
  });
  $provide.value('Messages_DS', {
    objectStoreName: 'Message',
    keyName: 'id'
  });
  $provide.value('Deliveries_Messages_DS', {
    objectStoreName: 'DeliveriesMessage',
    keyName: 'id'
  });
  $provide.value('Oms_Orders_Messages_DS', {
    objectStoreName: 'OmsOrdersMessage',
    keyName: 'id'
  });
  $provide.value('ThreePL_DS', {
    objectStoreName: 'ThreePL',
    keyName: 'id'
  });
  $provide.value('ThreePLTrainVouchers_DS', {
    objectStoreName: 'ThreePLTrainVouchers',
    keyName: 'id'
  });
  $provide.value('View_Settings_DS', {
    objectStoreName: 'ViewSettings',
    keyName: 'id'
  });
  $provide.value('Rule_Engine_DS', {
    objectStoreName: 'RuleEngine',
    keyName: 'id'
  });
  $provide.value('Rules_DS', {
    objectStoreName: 'Rules',
    keyName: 'id'
  });
  $provide.value('Three_PL_Services_DS', {
    objectStoreName: 'ThirdPartyService',
    keyName: 'id'
  });
  $provide.value('PdfFormTemplates_DS', {
    objectStoreName: 'PdfFormTemplates',
    keyName: 'id'
  });
  $provide.value('ContentTemplates_DS', {
    objectStoreName: 'contentTemplates',
    keyName: 'id'
  });
  $provide.value('RecurringServices_DS', {
    objectStoreName: 'recurringServices',
    keyName: 'id'
  });
  $provide.value('Dashboards_DS', {
    objectStoreName: 'dashboards',
    keyName: 'id'
  });
  $provide.value('Groups_DS', {
    objectStoreName: 'groups',
    keyName: 'id'
  });
  $provide.value('Custom_Order_Planning_Configuration_DS', {
    objectStoreName: 'CustomOrderPlanningConfiguration',
    keyName: 'id'
  });
  $provide.value('Teams_DS', {
    objectStoreName: 'teams',
    keyName: 'id'
  });
}
